'use strict';

const tableTd = "_table-td_1wtme_1";
const styles = {
	tableTd: tableTd
};

exports.styles = styles;
//# sourceMappingURL=TableTd.module-By-eeaGx.js.map
